<template>
    <v-container class="pt-1 pb-12 py-sm-12 px-4 px-sm-0">
      <v-row class="d-none d-sm-flex">
    <v-col :cols="12">
        <div class="title-container">
          <div class="title-block">
    <div class="d-flex align-center ga-3">
      <span class="page-title">{{ page.title }}</span>
      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on, attrs }">
          <v-btn small color="primary" text v-bind="attrs" v-on="on">
            <v-icon left>mdi-help-circle-outline</v-icon>Ajuda
          </v-btn>
        </template>
        <v-card min-width="380px">
          <v-card-title class="text-h6 font-weight-bold pb-2">
            <v-icon small class="mr-2">mdi-lightbulb-on</v-icon>Ajuda dos Campos
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-3 pb-3">
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🔖 Identificador</p><p class="text-caption grey--text">Número único que identifica esta Upbox no sistema</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">📡 Mac</p><p class="text-caption grey--text">Endereço de rede físico da Upbox</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">⚡ Valor pulso</p><p class="text-caption grey--text">Quanto tempo dura o sinal enviado para ligar a máquina (em ms)</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🔢 Quantidade de pulsos</p><p class="text-caption grey--text">Quantos sinais são enviados para a máquina por acionamento</p></div>
            <v-divider class="my-2"></v-divider>
            <div><p class="font-weight-bold text-caption mb-1">⏱️ Delay</p><p class="text-caption grey--text">Tempo de espera entre um sinal e outro (em ms)</p></div>
          </v-card-text>
        </v-card>
      </v-menu>
    </div>
    <v-breadcrumbs class="app-breadcrumb" divider="›" :items="dataset.breadcrumbItems"></v-breadcrumbs>
</div>
            <div class="button-group">
    <v-btn id="btnBack" type="button" elevation="0" outlined exact style="color: #3BA5DB !important; border-color: #3BA5DB !important;" to="/upboxes">Voltar</v-btn>
    <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
        :loading="dataset.loading">Salvar</v-btn>
</div>
        </div>
    </v-col>
</v-row>

<v-row class="d-sm-none d-lg-none d-md-flex">
    <v-col :cols="12">
        <div class="title-container">
            <div class="title-block">
                <div class="d-flex align-center">
                    <span class="page-title">{{ page.title }}</span>
                    <v-menu offset-y transition="slide-y-transition">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small color="primary" class="ml-2" v-bind="attrs" v-on="on">
                          <v-icon>mdi-help-circle-outline</v-icon>
                        </v-btn>
                      </template>
                      <v-card min-width="320px">
                        <v-card-title class="text-h6 font-weight-bold pb-2">
                          <v-icon small class="mr-2">mdi-lightbulb-on</v-icon>Ajuda dos Campos
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text class="pt-3 pb-3">
                          <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🔖 Identificador</p><p class="text-caption grey--text">Número único que identifica esta Upbox no sistema</p></div>
                          <v-divider class="my-2"></v-divider>
                          <div class="mb-3"><p class="font-weight-bold text-caption mb-1">📡 Mac</p><p class="text-caption grey--text">Endereço de rede físico da Upbox</p></div>
                          <v-divider class="my-2"></v-divider>
                          <div class="mb-3"><p class="font-weight-bold text-caption mb-1">⚡ Valor pulso</p><p class="text-caption grey--text">Quanto tempo dura o sinal enviado para ligar a máquina (em ms)</p></div>
                          <v-divider class="my-2"></v-divider>
                          <div class="mb-3"><p class="font-weight-bold text-caption mb-1">🔢 Quantidade de pulsos</p><p class="text-caption grey--text">Quantos sinais são enviados para a máquina por acionamento</p></div>
                          <v-divider class="my-2"></v-divider>
                          <div><p class="font-weight-bold text-caption mb-1">⏱️ Delay</p><p class="text-caption grey--text">Tempo de espera entre um sinal e outro (em ms)</p></div>
                        </v-card-text>
                      </v-card>
                    </v-menu>
                </div>
                <v-breadcrumbs class="app-breadcrumb" divider="›" :items="dataset.breadcrumbItems"></v-breadcrumbs>
            </div>
        </div>
    </v-col>
</v-row>

        <v-row class="d-sm-none d-lg-none d-md-flex">
            <v-col>
               <div class="button-group">
     <v-btn id="btnBack" type="button" elevation="0" outlined exact style="color: #3BA5DB !important; border-color: #3BA5DB !important;" to="/upboxes">Voltar</v-btn>
    <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
        :loading="dataset.loading">Salvar</v-btn>
</div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="6" class="pb-3">
                                            <v-text-field readonly disabled dense label="Identificador"
                                                v-model="dataset.data.identificador" required :rules="[$rules.required]"
                                                outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" class="pb-3">
                                            <v-text-field readonly disabled dense label="Mac" v-model="dataset.data.mac"
                                                required hide-details="auto" outlined>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6" class="pb-3">
                                            <v-text-field dense type="number" label="Valor pulso"
                                                v-model="dataset.data.valorPulso" required outlined hide-details="auto"
                                                :rules="[$rules.required]" suffix="milisegundo(s)">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" class="pb-3">
                                            <v-text-field readonly disabled dense type="number" label="Quantidade de canais"
                                                v-model="dataset.data.quantidadeCanais" required outlined
                                                hide-details="auto" :rules="[$rules.required]">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6" class="pb-3">
                                            <v-text-field dense type="number" min="0" max="100" label="Quantidade de pulsos"
                                                v-model="dataset.data.quantidadePulsos" required outlined
                                                hide-details="auto" :rules="[$rules.required]">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" class="pb-3">
                                            <v-text-field min="0" max="10000" dense type="number" label="Delay"
                                                v-model="dataset.data.delayPulsos" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">
                                    <v-row>
                                        <v-col>
                                            <span>
                                                Informações
                                            </span>
                                        </v-col>
                                    </v-row>
                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <span v-if="dataset.loadingInfos">
                                                Carregando informações...
                                            </span>
                                            <span v-if="!dataset.loadingInfos && dataset.errorUpboxInfo">
                                                {{ dataset.errorUpboxInfo }}
                                            </span>
                                            <span v-if="!dataset.loadingInfos && dataset.dataInfo">
                                                <strong>IP: </strong>{{ dataset.dataInfo.ip }}
                                                <br>
                                                <strong>Versão: </strong> {{ dataset.dataInfo.versao }}
                                                <br>
                                                <strong>Status: </strong> {{ dataset.dataInfo.status }}
                                                <br>
                                                <strong>Data: </strong> {{
                                                    $moment(dataset.dataInfo.data).format("DD/MM/YYYY HH:mm") }}
                                                <br>
                                                <strong>Sinal: </strong>{{ getTextBySignal(dataset.dataInfo.forcaSinal)
                                                }} <v-icon :color="getIconColorBySignal(dataset.dataInfo.forcaSinal)">
                                                    {{ getIconBySignal(dataset.dataInfo.forcaSinal) }}</v-icon>
                                            </span>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-text>
                                    <v-btn type="button" outlined elevation="0" color="primary" dark
                                        @click="loadUpboxInfo()" :loading="dataset.loadingInfos">
                                        <v-icon class="mr-2">
                                            mdi-refresh
                                        </v-icon>
                                        Solicitar Infos
                                    </v-btn>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>

    </v-container>
</template>

<script>
import string from "@/common/util/string"
import object from "@/common/util/object"

import axios from "axios"
import { eventHub } from "@/main"

export default {
    name: "UpboxDetails",

    data: () => ({
        page: {
            title: "",
        },
        dataset: {
            data: {},
            dataInfo: null,
            breadcrumbItems: [],
            loading: false,
            loadingInfos: false,
            errorUpboxInfo: null
        },
        dataForm: {
            validForm: true,
        },
    }),

    created() {
        this.loadData()
    },

    mounted() {
  eventHub.$on('CHANGE-OPERATION', () => {
    this.$router.push('/upboxes');
  });
  this.loadData();
},
destroyed() {
  eventHub.$off('CHANGE-OPERATION');
},

    methods: {
        goBack() {
            this.$router.replace("/upboxes");
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();

            await this.load();
        },

        setPage() {
            this.page.title = `Detalhes da upbox`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Listagem de upbox",
                disabled: false,
                to: "/upboxes",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.isNew ? `Incluir` : `Detalhes da upbox`,
                disabled: true,
                exact: true,
            });
        },

        async load() {
            this.dataset.loading = true

            try {
                const result = await axios.get(`/api/upbox/${this.$route.params.id}`);

                this.dataset.data = result.data

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataset.loading = false;
            }
        },

        async loadUpboxInfo() {
            this.dataset.loadingInfos = true

            this.dataset.errorUpboxInfo = null;
            this.dataset.dataInfo = null;

            try {
                const result = await axios.get(`/api/upbox/${this.$route.params.id}/info`);

                this.dataset.dataInfo = result.data

            } catch (error) {
                if (error.response && error.response.data.detalhe)
                    this.dataset.errorUpboxInfo = error.response.data.detalhe

                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataset.loadingInfos = false;
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar a upbox?',
                title: 'Atualizar upbox',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.put(`/api/upbox/${this.$route.params.id}`, payload, { config: { headers: { "Content-Type": "application/json" } } });

                this.$dialog.notify.info("Upbox salva com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        getTextBySignal(signal) {
            switch (signal) {
                case 1:
                    return 'Muito ruim'
                case 2:
                    return 'Ruim'
                case 3:
                    return 'Bom'
                case 4:
                    return 'Ótimo'
                case 5:
                    return 'Excelente'
                default:
                    break;
            }
        },

        getIconBySignal(signal) {
            switch (signal) {
                case 1:
                    return 'mdi-wifi-strength-alert-outline'
                case 2:
                    return 'mdi-wifi-strength-1'
                case 3:
                    return 'mdi-wifi-strength-2'
                case 4:
                    return 'mdi-wifi-strength-3'
                case 5:
                    return 'mdi-wifi-strength-4'
                default:
                    break;
            }
        },

        getIconColorBySignal(signal) {
            switch (signal) {
                case 1:
                case 2:
                    return 'error'
                case 3:
                    return 'amber'
                case 4:
                case 5:
                    return 'green'
                default:
                    break;
            }
        },

        buildPayload() {
            let data = {
                identificador: this.dataset.data.identificador,
                mac: this.dataset.data.mac,
                quantidadeCanais: this.dataset.data.quantidadeCanais,
                valorPulso: this.dataset.data.valorPulso,
                quantidadePulsos: parseInt(this.dataset.data.quantidadePulsos.toString()),
                operacaoId: this.dataset.data.operacao.id
            }

            if (this.dataset.data.delayPulsos) {
                data.delayPulsos = parseInt(this.dataset.data.delayPulsos.toString())
            }

            return data;
        },




    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}
.ga-3 { gap: 24px; }

@media (max-width: 768px) {
  .button-group {
    display: flex !important;
    width: 100% !important;
    gap: 12px !important;
    margin-top: 8px !important;
    margin-bottom: 16px !important;
  }

  .button-group .v-btn {
    flex: 1 !important;
    min-width: unset !important;
  }
}

</style>